/**
 * utm.js — Captura y persistencia de parámetros de campaña (UTM).
 *
 * Los parámetros llegan por la URL (?utm_source=...&utm_medium=...&utm_campaign=...).
 * Se guardan en sessionStorage para que sobrevivan la navegación entre páginas
 * (SPA) y se envíen junto con la creación de tickets y el registro de proveedores.
 *
 * Se acepta `campaign_id` como alias de `utm_campaign`.
 * Atribución "primer toque": no se sobrescribe una campaña ya guardada en la sesión.
 */

const STORAGE_KEY = 'providers_utm';

/**
 * Lee los parámetros UTM de la URL actual y, si hay alguno, los persiste en
 * sessionStorage (solo la primera vez de la sesión).
 */
export function captureUtmParams(search = window.location.search) {
  try {
    const params = new URLSearchParams(search);
    const utm = {
      utm_source: params.get('utm_source'),
      utm_medium: params.get('utm_medium'),
      utm_campaign: params.get('utm_campaign') || params.get('campaign_id'),
    };

    const hasAny = utm.utm_source || utm.utm_medium || utm.utm_campaign;
    if (!hasAny) return;

    // Primer toque: no pisar una campaña ya capturada en esta sesión
    if (sessionStorage.getItem(STORAGE_KEY)) return;

    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(utm));
  } catch (_) {
    // Nunca romper la app por tracking
  }
}

/**
 * Devuelve los parámetros UTM guardados, listos para incluir en un payload.
 * Si no hay ninguno, devuelve un objeto vacío.
 */
export function getUtmParams() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const utm = JSON.parse(raw);
    return {
      utm_source: utm.utm_source || null,
      utm_medium: utm.utm_medium || null,
      utm_campaign: utm.utm_campaign || null,
    };
  } catch (_) {
    return {};
  }
}
